import React from 'react';
import AddImage from '../assets/img/icons/AddImage.svg'

export const FormFileInputImage = (): JSX.Element => {
    return (
        <div className="relative w-[48px] h-[48px]">
            <img className="absolute w-[38px] h-[38px] top-[3px] left-[7px]" alt="Path" src={AddImage} />
        </div>
    );
};